import { RagChip } from "@/components/ui/rag";

export function EvidenceReadinessTable({ domains }) {
  const totalItems = domains.reduce((acc, d) => acc + d.items.length, 0);
  return (
    <section className="paper-card overflow-hidden">
      <div className="flex items-center justify-between border-b border-border bg-card/80 px-6 py-4">
        <div>
          <p className="eyebrow">§ 05 · E — Evidence map</p>
          <h3 className="font-display text-lg font-medium text-foreground">Evidence readiness table</h3>
        </div>
        <span className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
          {totalItems} items · grouped by domain
        </span>
      </div>
      <div className="divide-y divide-border">
        {domains.map((domain) => {
          if (domain.items.length === 0) return null;
          return (
            <div key={domain.key} className="bg-card">
              <div className="flex items-center gap-3 bg-muted/40 px-6 py-3">
                <span className="letter-mark h-6 w-6 text-[11px]">{domain.key}</span>
                <p className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-foreground">
                  {domain.title}
                </p>
                <RagChip rag={domain.rag} className="ml-auto" />
              </div>
              <ul>
                {domain.items.map((item) => (
                  <li
                    key={item.id}
                    className="grid grid-cols-1 gap-2 border-t border-border px-6 py-4 md:grid-cols-12 md:items-start md:gap-4"
                  >
                    <div className="md:col-span-1 md:pt-0.5">
                      <span className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
                        {String(item.number).padStart(2, "0")}
                      </span>
                    </div>
                    <div className="md:col-span-7">
                      <p className="font-display text-[15px] font-medium leading-tight text-foreground">
                        {item.title}
                      </p>
                      <p className="mt-0.5 text-xs leading-relaxed text-muted-foreground">
                        {item.helper}
                      </p>
                      {item.applicability === "not_applicable" && item.notApplicableReason && (
                        <p
                          className="mt-1 text-xs italic leading-relaxed text-foreground/70"
                          data-testid={`evidence-na-reason-${item.id}`}
                        >
                          Not applicable — {item.notApplicableReason}
                        </p>
                      )}
                      {item.evidenceNote && (
                        <p
                          className="mt-1 text-xs leading-relaxed text-foreground/70"
                          data-testid={`evidence-note-display-${item.id}`}
                        >
                          Evidence note — {item.evidenceNote}
                        </p>
                      )}
                    </div>
                    <div className="flex flex-col items-start gap-1 md:col-span-4 md:items-end">
                      <RagChip rag={item.rag}>{item.shortLabel}</RagChip>
                      {item.canonicalState && (
                        <span
                          className="font-mono-label inline-flex rounded-sm border border-border bg-card px-2 py-0.5 text-[10px] uppercase tracking-[0.18em] text-foreground"
                          data-testid={`canonical-state-${item.id}`}
                        >
                          {item.canonicalState}
                        </span>
                      )}
                      {item.fieldVerificationLabel && (
                        <span
                          className="font-mono-label text-[10px] uppercase tracking-[0.18em] text-muted-foreground"
                          data-testid={`field-verification-${item.id}`}
                        >
                          Field verification · {item.fieldVerificationLabel}
                        </span>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </section>
  );
}
